import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=72058383&scoped=true"
import script from "./not-found.vue?vue&type=script&lang=ts"
export * from "./not-found.vue?vue&type=script&lang=ts"
import style0 from "./not-found.vue?vue&type=style&index=0&id=72058383&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72058383",
  null
  
)

export default component.exports